import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { authService } from "../../services/auth/authService";

// Déconnexion telle que CommonHeader la faisait, partagée par toutes les entrées « Déconnexion »
// de la coquille (barre du haut, tiroir mobile, en-tête candidat).
export function useLogout() {
  const navigate = useNavigate();
  return useCallback(() => {
    authService()
      .logout()
      .then(
        () => navigate("/"),
        () => {
          //do nothing
        },
      );
  }, [navigate]);
}
